import { useCallback } from "react";

import { useSlashCommands } from "../../hooks";
import { ChatFormTextInput } from "./chat-form-text-input";
import { PlaybooksSlashCommandMenu } from "./playbooks-slash-command-menu";

export const ChatFormTextInputWithSlashCommands = () => {
  const slashCommands = useSlashCommands();

  const handleInputChange = useCallback(
    (event: React.ChangeEvent<HTMLTextAreaElement>) => {
      slashCommands.onInputChange(event);
    },
    [slashCommands]
  );

  const handleTextareaClick = useCallback(
    (event: React.MouseEvent<HTMLTextAreaElement>) => {
      slashCommands.onInputClick(event);
    },
    [slashCommands]
  );

  const handleTextareaKeyDown = useCallback(
    (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
      slashCommands.onInputKeyDown(event);
    },
    [slashCommands]
  );

  return (
    <PlaybooksSlashCommandMenu commandState={slashCommands.commandState} onClose={slashCommands.closeMenu}>
      <ChatFormTextInput onChange={handleInputChange} onClick={handleTextareaClick} onKeyDown={handleTextareaKeyDown} />
    </PlaybooksSlashCommandMenu>
  );
};
